<div class="tags-container properties" ng-controller="WorkflowTagsController as ctrl">
    <header>
        <h1>{{'workFlowTag.header'|translate}}</h1>
        <p class="form-description">{{'workflowTag.usage.description'|translate}}</p>
    </header>
</div>
